<h1 mat-dialog-title>Seleccionar Potencia</h1>
<div mat-dialog-content>
  <p class="description">Seleccione la potencia para la luminaria:</p>
  <div class="potencias-container">
    <div *ngFor="let potencia of potencias">
      <button
        mat-button
        [ngClass]="{ selected: selectedPotencia === potencia }"
        (click)="seleccionarPotencia(potencia)"
      >
        {{ potencia }}%
      </button>
    </div>
  </div>
</div>
<div class="button-container" mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button
    mat-button
    [disabled]="!(selectedPotencia || selectedPotencia === 0)"
    (click)="confirmarPotencia()"
  >
    {{ data.modo === "encender" ? "Encender" : "Dimerizar" }}
  </button>
</div>
